export const detectDeviceType = (): string => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (
    /iphone|ipod/.test(userAgent) ||
    /ipad/.test(userAgent) ||
    (/macintosh/.test(userAgent) && 'ontouchend' in document)
  ) {
    return 'iOS';
  } else if (/android/.test(userAgent)) {
    return 'Android';
  } else if (/windows|macintosh|linux/.test(userAgent)) {
    return 'Desktop';
  } else {
    return 'Unknown';
  }
};
